<template>
  <ImagePreview
    :url="imageURL"
    class="tw-inline-flex tw-h-64 tw-max-w-full tw-min-w-[300px] tw-bg-gray-700 tw-rounded"
  >
    <div
      class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-p-2 tw-flex tw-items-center tw-justify-between tw-bg-black/75 tw-text-white"
    >
      <button
        type="button"
        class="btn btn-secondary btn-sm tw-inline-flex tw-items-center"
        @click="showPicker = true"
      >
        <icon-carbon-image-search class="tw-mr-1 tw-w-6 tw-h-6" />
        Bild wählen
      </button>
      <button
        v-if="imageId.value"
        type="button"
        class="btn text-white btn-sm tw-inline-flex tw-items-center"
        @click="localImageId = undefined"
      >
        Bildauswahl aufheben
      </button>
    </div>
  </ImagePreview>
  <ImagePickerDialog
    v-if="showPicker"
    v-model="localImageId"
    :is-open="true"
    :default-license-id="defaultLicenseId"
    @show="showPicker = $event"
  />
</template>

<script lang="ts" setup>
import { computed, Ref, ref } from 'vue'
import ImagePickerDialog from './AppImagePickerDialog.vue'
import ImagePreview from './AppImagePreview.vue'
import { useUpdatableState } from './util'

const props = defineProps<{
  imageId: Ref<number>
  defaultLicenseId: number
  imageURLTemplate: string
}>()
const emit = defineEmits<{
  (e: 'update', imageId: number | undefined): void
}>()

const showPicker = ref(false)
const localImageId = useUpdatableState<number | undefined>(
  computed(() => props.imageId.value),
  (value) => emit('update', value),
)
const imageURL = computed(() =>
  props.imageId.value
    ? props.imageURLTemplate.replace('__id__', props.imageId.value.toString())
    : undefined,
)
</script>
